import {combineReducers} from "redux";
import MapXBulkImportReducers from "store/bulk-import/bulkImportReducer";
import marketReportReducer from "store/market-report/marketReportReducers";
import refreshCandidateReducer from "store/refresh-candidate/refreshCandidatesReducer";
import MapXAPReducers from "store/additional-profiles/additionalProfilesReducers";
import MapXCandidateReducers from "store/candidate/candidateReducers";
import MapXCompanyReducers from "store/company/companyReducers";
import MapXEventTrackingReducers from "store/events/eventTrackingReducers";
import MapXFilterReducers from "store/filter/filterReducers";
import MapXLearnToRankReducers from "store/learn-to-rank/learnToRankReducers";
import marketMapReducer from "store/market-map/marketMapReducers";
import MapXOrganisationReducers from "store/organisation/organisationReducers";
import MapXPaymentReducers from "store/payment/paymentReducers";
import MapxProjectListReducer from "store/project-list/projectListReducer";
import MapxProjectReducer from "store/project/projectReducer";
import MapXSearchReducers from "store/search/searchReducers";
import MapXTargetListReducers from "store/target-list/targetListReducers";
import MapXUserReducers from "store/user/userReducers";
import backgroundTaskReducer from "store/background-tasks/backgroundTaskReducer";
import layoutReducer from "store/layout/layoutReducers";
import userPreferenceReducers from "store/userPreference/userPreferenceReducers";
import polarisReducer from "store/polaris/polarisSlice";
import extendedSearchReducer from "store/extended-search/extendedSearchSlice";
import reportBuilderReducer from "store/report-builder/reportBuilderSlice";

const appReducer = combineReducers({
	candidate: MapXCandidateReducers,
	bulkImport: MapXBulkImportReducers,
	backgroundTask: backgroundTaskReducer,
	refresh_candidate: refreshCandidateReducer,
	company: MapXCompanyReducers,
	events: MapXEventTrackingReducers,
	filter: MapXFilterReducers,
	search: MapXSearchReducers,
	targetList: MapXTargetListReducers,
	projectList: MapxProjectListReducer,
	user: MapXUserReducers,
	mapxProject: MapxProjectReducer,
	additional_profiles: MapXAPReducers,
	organisation: MapXOrganisationReducers,
	learn_to_rank: MapXLearnToRankReducers,
	market_map: marketMapReducer,
	marketReport: marketReportReducer,
	payment: MapXPaymentReducers,
	layout: layoutReducer,
	userPreference: userPreferenceReducers,
	polaris: polarisReducer,
	extendedSearch: extendedSearchReducer,
	reportBuilder: reportBuilderReducer,
});

const rootReducer = (state, action) => {
	// if (action.type === LOGOUT) {
	// 	state = undefined;
	// }

	return appReducer(state, action);
};

export default rootReducer;
